import { Component, OnDestroy } from "@angular/core";
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from "@angular/router";
import { reserved } from "./core/models/reservedWord";
import { EventService } from "./core/services/event.service";
import { StabilityService } from "./core/services/stability.service";

import { Subject } from "rxjs";
import { MsalService } from "@azure/msal-angular";
import { MsalTokenService } from "./core/services/msal-token.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnDestroy {
  title = "Oasis";
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private eventService: EventService,
    private app: StabilityService,
    private msalService: MsalService,
    private token: MsalTokenService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.setupRouterEvents();
    this.app.checkNetworkStatus();
    this.app.versionDetection();
    await this.initializeMsal();
    this.token.getMicrosoftToken(true).subscribe();
  }

  async initializeMsal(): Promise<void> {
    // Initialize MSAL
    await this.msalService.instance.initialize();

    // Handle redirect response
    this.msalService.instance.handleRedirectPromise().then((response) => {
      if (response) {
        this.msalService.instance.setActiveAccount(response.account);
      }
    });
  }

  setupRouterEvents(): void {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart:
          this.eventService.broadcast(reserved.isLoading, true);
          break;

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError:
          this.eventService.broadcast(reserved.isLoading, false);
          break;

        default:
          break;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
